import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { AppendToBodyDirective } from './append-to-body.directive'
import { AutoFocusDirective } from './auto-focus.directive'
import { ClickOutsideDirective } from './click-outside.directive'
import { DebounceDblClickDirective } from './debounce-dbl-click.directive'
import { OnDestroyDirective } from './on-destroy.directive'
import { OnEscapeDirective } from './on-escape.directive'
import { StopClickPropagationDirective } from './stop-click-propagation.directive'
import { VarDirective } from './var.directive'
import { AutoClickDirective } from './auto-click.directive'
import { ReferenceReprDirective } from './reference-repr.directive'
import { AutoSelectDirective } from './auto-select.directive'
import { HotkeyDirective } from './hotkey.directive'
import { DragAndDropDirective } from './drag-and-drop-directive.directive'
import { FavoriteButtonDirective } from './favorite-button.directive'

@NgModule({
  declarations: [
    AppendToBodyDirective,
    AutoFocusDirective,
    ClickOutsideDirective,
    DebounceDblClickDirective,
    OnDestroyDirective,
    OnEscapeDirective,
    StopClickPropagationDirective,
    VarDirective,
    AutoClickDirective,
    ReferenceReprDirective,
    AutoSelectDirective,
    HotkeyDirective,
    DragAndDropDirective,
    FavoriteButtonDirective
  ],
  imports: [CommonModule],
  exports: [
    AppendToBodyDirective,
    AutoFocusDirective,
    ClickOutsideDirective,
    DebounceDblClickDirective,
    OnDestroyDirective,
    OnEscapeDirective,
    StopClickPropagationDirective,
    VarDirective,
    AutoClickDirective,
    ReferenceReprDirective,
    AutoSelectDirective,
    HotkeyDirective,
    DragAndDropDirective,
    FavoriteButtonDirective
  ]
})
export class DirectivesModule {}
